import type { RouterResult } from './browser-types'
import { browserFallbackRegistry, BROWSER_NOOP_ACTIONS, BROWSER_PERMISSION_ACTIONS } from './fallbacks'

export const resolveRouterAction = (namespace: string, action: string, payload?: unknown): RouterResult => {
  const actionMap = browserFallbackRegistry[namespace]
  if (actionMap?.[action]) {
    return actionMap[action](payload)
  }

  if (BROWSER_NOOP_ACTIONS.has(action)) {
    return undefined
  }

  if (BROWSER_PERMISSION_ACTIONS.has(action)) {
    return false
  }

  if (action === 'showOpenDialog') {
    return { canceled: true, filePaths: [] }
  }

  console.warn(`[browser-runtime] Unhandled router action: ${namespace}/${action}`, payload)
  return null
}
